<template>
  <b-form>
    <b-form-row class="mt-3">
      <b-col cols="9"  offset="1">
        <h4>{{title}}</h4>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="10" offset="1">
        <b-form-group label="Korte titel:"
                      label-for="title"
                      label-cols="2"
                      content-cols="10">
          <b-form-input id="title"
                        v-model="titleVal"
                        @keyup="$emit('update:titleShort', titleVal);" />
        </b-form-group>
        <b-form-group label="Volledige titel:"
                      label-for="fullTitle"
                      label-cols="2"
                      content-cols="10">
          <b-form-input id="fullTitle"
                        v-model="fullTitleVal"
                        @keyup="$emit('update:fullTitle', fullTitleVal);" />
        </b-form-group>
        <b-form-group label="Beschrijving kort:"
                      label-for="descriptionshort"
                      label-cols="2"
                      content-cols="10">
          <b-form-input id="descriptionshort"
                        v-model="descriptionShortVal"
                        @keyup="$emit('update:descriptionShort', descriptionShortVal);" />
        </b-form-group>
        <b-form-group label="Beschrijving lang:"
                      label-for="descriptionlong"
                      label-cols="2"
                      content-cols="10">
          <vue-editor id="descriptionlong"
                      v-model="descriptionLongVal"                      
                      :editorToolbar="customToolbar"
                      @text-change="$emit('update:descriptionLong', descriptionLongVal);" />
        </b-form-group>
      </b-col>
    </b-form-row>
  </b-form>
</template>
<script>
  import { VueEditor } from "vue2-editor";

  export default {
    name: 'ArticleTranslation',
    components: {
      VueEditor
    },
    data() {
      return {
        titleVal: this.titleShort,
        fullTitleVal: this.fullTitle,
        descriptionLongVal: this.descriptionLong,
        descriptionShortVal: this.descriptionShort,
        customToolbar: [
          [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          ["bold", "italic", "underline"], // toggled buttons
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" }
          ],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent          
          ["clean"] // remove formatting button
        ]
      }
    },
    props: {
      title: String,
      titleShort: String,
      fullTitle: String,
      descriptionShort: String,
      descriptionLong: String,
    },
  }
</script>

<style>
  #descriptionlong {
    height: 200px;
  }
</style>
